module.exports = __webpack_public_path__ + "static/media/googleEmojis.39c26902.png";